import { useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Lightbox } from "@/components/Lightbox";
import { CENTRAL_HEIGHTS } from "@/constants/content";
import { ImageDisclaimer } from "@/components/ImageDisclaimer";

export const CentralHeightsShowcase = () => {
  const trackRef = useRef(null);
  const [index, setIndex] = useState(null);
  const { showcase } = CENTRAL_HEIGHTS;

  const scrollBy = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    const card = el.querySelector(".cp-heights-scroll-card");
    const delta = (card?.offsetWidth || 400) + 24;
    el.scrollBy({ left: dir * delta, behavior: "smooth" });
  };

  return (
    <section
      id="central-heights-plans"
      className="cp-section cp-section--cream cp-heights-showcase"
      data-testid="central-heights-showcase-section"
    >
      <div className="cp-container">
        <Reveal className="cp-section-head">
          <span className="cp-eyebrow">Central Heights</span>
          <h2 className="cp-h2">Towers &amp; Interiors</h2>
          <p className="cp-section-desc">Swipe through the project exterior and interior renders.</p>
        </Reveal>

        <div className="cp-heights-scroll-toolbar">
          <span className="cp-heights-scroll-hint">Swipe to browse</span>
          <div className="cp-heights-scroll-nav">
            <button type="button" className="cp-heights-scroll-btn" onClick={() => scrollBy(-1)} aria-label="Previous slide">
              <ChevronLeft size={18} />
            </button>
            <button type="button" className="cp-heights-scroll-btn" onClick={() => scrollBy(1)} aria-label="Next slide">
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

        <div className="cp-heights-scroll-outer">
          <div className="cp-heights-scroll" ref={trackRef} data-testid="central-heights-horizontal-scroll">
            {showcase.map((item, i) => (
              <button
                key={item.src}
                type="button"
                className="cp-heights-scroll-card"
                onClick={() => setIndex(i)}
                data-testid={`central-heights-slide-${i}`}
              >
                <img src={item.src} alt={item.alt} loading="lazy" draggable={false} />
                <span className="cp-heights-scroll-label">{item.label}</span>
              </button>
            ))}
          </div>
        </div>
        <ImageDisclaimer className="cp-heights-gallery-disclaimer" />
      </div>

      <Lightbox
        images={showcase}
        index={index}
        onClose={() => setIndex(null)}
        onPrev={() => setIndex((index - 1 + showcase.length) % showcase.length)}
        onNext={() => setIndex((index + 1) % showcase.length)}
      />
    </section>
  );
};
